import i18n from "../../../constants/i18n";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import {
  KhattabatAssignClientActions,
  KhattabatAssignClientTypeSelector
} from "./KhattabatAssignClientPopUpActions";


const KhattabatClientAssignConfirmationPopUp = withLiteObserverAndTheme(
  (props) => {
    const { theme } = props;
    const { colors } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1500}
        height={1080}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => { }}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="column"
          justifyContent="space-between"
          alignItems="center"
          withShadow={true}
          width={1000}
          height={420}
          color={colors.all.white}
          style={{
            position: "relative",
            borderRadius: 50,
            zIndex: 5
          }}
          onClick={() => { }}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={24}
            text={i18n.get("ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP")}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />

          <KhattabatAssignClientTypeSelector />

          <KhattabatAssignClientActions />
        </ET3Div>
      </ET3Div>
    );
  }
);

export default KhattabatClientAssignConfirmationPopUp;
